////////////////////////////////////// WARNING ///////////////////////////////////////////////
//! THIS UTILITY FUNCTION HAS BEEN COPIED INTO MULTIPLE REPOSITORIES.
//! ANY CHANGES MADE HERE MUST BE COPIED OVER TO THE FOLLOWING FILES:
// - tools/food-cost-calculator/src/helpers/getEndpoint.ts
// - html/wp-content/plugins/ls_import/src/helpers/getEndpoint.ts
//////////////////////////////////////////////////////////////////////////////////////////////

const subdirectoryList: { ch: string; dech: string } = {
    ch: '/ch',
    dech: '/ch-de',
};

type SubDirKeys = keyof typeof subdirectoryList;

const removeTrailingSlash = (url: string): string => url.replace(/\/$/g, '');

const isPathInSubdirectoryValues = (subdirPath: string) =>
    Object.values(subdirectoryList).includes(subdirPath);
const extractSubdirectoryFromPathName = () => {
    const subdir = window.location.pathname.split('/')[1];
    const subdirPath = subdir ? `/${subdir}` : '';
    return isPathInSubdirectoryValues(subdirPath) ? subdirPath : '';
};

const domain: string = document.body.dataset.domain ?? '';

const isSubdirectory = (domain: string) => domain in subdirectoryList;
const createPathFromDomain = (domain: string) => {
    if (domain) {
        if (!isSubdirectory(domain)) return ''; // This applies to all root domains including hq, nl, etc.

        const subdirectory: SubDirKeys = domain as SubDirKeys;
        return removeTrailingSlash(subdirectoryList[subdirectory]);
    }
    if (!extractSubdirectoryFromPathName()) return '';

    return removeTrailingSlash(extractSubdirectoryFromPathName());
};

const isRelativeURL = (url: string) => url.startsWith('/');

const getEndpoint = (url = '') => {
    return isRelativeURL(url) ? createPathFromDomain(domain) + url : url;
};

export { getEndpoint };
